/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PersonaleRapportinoCreateDTO
 */
export interface PersonaleRapportinoCreateDTO {
    /**
     * 
     * @type {number}
     * @memberof PersonaleRapportinoCreateDTO
     */
    idPersonale?: number;
    /**
     * 
     * @type {Date}
     * @memberof PersonaleRapportinoCreateDTO
     */
    dataDaMattino?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof PersonaleRapportinoCreateDTO
     */
    dataAMattino?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof PersonaleRapportinoCreateDTO
     */
    dataDaPomeriggio?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof PersonaleRapportinoCreateDTO
     */
    dataAPomeriggio?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof PersonaleRapportinoCreateDTO
     */
    oreTotali?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PersonaleRapportinoCreateDTO
     */
    oreViaggio?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PersonaleRapportinoCreateDTO
     */
    viaggio?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PersonaleRapportinoCreateDTO
     */
    pernottamenti?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof PersonaleRapportinoCreateDTO
     */
    dataIntervento?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof PersonaleRapportinoCreateDTO
     */
    idCommessa?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PersonaleRapportinoCreateDTO
     */
    descrizioneCommessa?: string | null;
}

/**
 * Check if a given object implements the PersonaleRapportinoCreateDTO interface.
 */
export function instanceOfPersonaleRapportinoCreateDTO(value: object): value is PersonaleRapportinoCreateDTO {
    return true;
}

export function PersonaleRapportinoCreateDTOFromJSON(json: any): PersonaleRapportinoCreateDTO {
    return PersonaleRapportinoCreateDTOFromJSONTyped(json, false);
}

export function PersonaleRapportinoCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonaleRapportinoCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idPersonale': json['idPersonale'] == null ? undefined : json['idPersonale'],
        'dataDaMattino': json['dataDaMattino'] == null ? undefined : (new Date(json['dataDaMattino'])),
        'dataAMattino': json['dataAMattino'] == null ? undefined : (new Date(json['dataAMattino'])),
        'dataDaPomeriggio': json['dataDaPomeriggio'] == null ? undefined : (new Date(json['dataDaPomeriggio'])),
        'dataAPomeriggio': json['dataAPomeriggio'] == null ? undefined : (new Date(json['dataAPomeriggio'])),
        'oreTotali': json['oreTotali'] == null ? undefined : json['oreTotali'],
        'oreViaggio': json['oreViaggio'] == null ? undefined : json['oreViaggio'],
        'viaggio': json['viaggio'] == null ? undefined : json['viaggio'],
        'pernottamenti': json['pernottamenti'] == null ? undefined : json['pernottamenti'],
        'dataIntervento': json['dataIntervento'] == null ? undefined : (new Date(json['dataIntervento'])),
        'idCommessa': json['idCommessa'] == null ? undefined : json['idCommessa'],
        'descrizioneCommessa': json['descrizioneCommessa'] == null ? undefined : json['descrizioneCommessa'],
    };
}

export function PersonaleRapportinoCreateDTOToJSON(json: any): PersonaleRapportinoCreateDTO {
    return PersonaleRapportinoCreateDTOToJSONTyped(json, false);
}

export function PersonaleRapportinoCreateDTOToJSONTyped(value?: PersonaleRapportinoCreateDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idPersonale': value['idPersonale'],
        'dataDaMattino': value['dataDaMattino'] == null ? undefined : ((value['dataDaMattino'] as any).toISOString()),
        'dataAMattino': value['dataAMattino'] == null ? undefined : ((value['dataAMattino'] as any).toISOString()),
        'dataDaPomeriggio': value['dataDaPomeriggio'] == null ? undefined : ((value['dataDaPomeriggio'] as any).toISOString()),
        'dataAPomeriggio': value['dataAPomeriggio'] == null ? undefined : ((value['dataAPomeriggio'] as any).toISOString()),
        'oreTotali': value['oreTotali'],
        'oreViaggio': value['oreViaggio'],
        'viaggio': value['viaggio'],
        'pernottamenti': value['pernottamenti'],
        'dataIntervento': value['dataIntervento'] == null ? undefined : ((value['dataIntervento'] as any).toISOString()),
        'idCommessa': value['idCommessa'],
        'descrizioneCommessa': value['descrizioneCommessa'],
    };
}

